import {LONGHAND_TO_CSS_PROPERTY, type LonghandId} from '../longhands';
import type {CSSWriter} from '@packages/systems/style/writers';

export type ValueType = string | number;
export type DeclarationType = [LonghandId, ValueType];

export class PropertyDeclarationBlock {
  map: Map<LonghandId, ValueType>;

  // TODO if we don't need to support CSS fallbacks,
  // we could accept an object here, otherwise with an
  // object we need alternative syntax for fallbacks.
  constructor(decl?: DeclarationType[]) {
    this.map = new Map(decl);
  }

  /*:: @@iterator: () => Iterator<DeclarationType>; */

  [Symbol.iterator]() {
    return this.map.entries();
  }

  get size() {
    return this.map.size;
  }

  has(prop: LonghandId): boolean {
    return this.map.has(prop);
  }

  get(prop: LonghandId): ValueType | undefined {
    return this.map.get(prop);
  }

  set(prop: LonghandId, value: ValueType): void {
    this.map.set(prop, value);
  }

  delete(prop: LonghandId): boolean {
    return this.map.delete(prop);
  }

  toCSS(writer: CSSWriter): void {
    for (const longhand of this.map.keys()) {
      const prop = LONGHAND_TO_CSS_PROPERTY[longhand];
      const value = this.map.get(longhand);
      if (prop && value != null) {
        writer.addDeclaration(prop, value);
      }
    }
  }

  toJSON(): DeclarationType[] {
    const entries: Array<DeclarationType> = [];
    for (const entry of this.map.entries()) {
      entries.push(entry);
    }
    return entries;
  }
}
